import { render } from "./CopyRight.vue?vue&type=template&id=4cc270eb&scoped=true"
const script = {}

import "./CopyRight.vue?vue&type=style&index=0&id=4cc270eb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cc270eb"]])

export default __exports__